import React from 'react';
import CptQuantity from './CptQuantity';
import { ComponentPrice, getComponentPrice } from './PanelPriceDisplay';

/**
 * Displays an InputField row used for Panel customization.
 */
const ComponentRow = ({
	inputFieldType,
	nameColumnWidth,
	cptColumnWidth,
	displayCheckbox,
	inputField,
	disabled,
	checked,
	handleCheck,
	isMedicareOrder,
	parentChecked,
	showCptQuantity,
	cptQuantityMap,
	splitCptQty,
	disableCptQtyUpdate,
	isEditingCptQuantity,
	updateCptQuantity,
	priceMap,
	priceDisplayType
}) => {

	const componentPrice = getComponentPrice({
		priceType: priceDisplayType,
		priceMap,
		calculateBasePrice: false,
		inputFieldId: inputField?.id
	});

	let rowClass = 'row';
	if (componentPrice) {
		rowClass += ' component-price-row';
	}

	return (
		<div className={rowClass}>
		<div className='d-flex justify-content-between'>
			<div className={'col-' + nameColumnWidth}>
				<div className="checkbox mt-0 mb-0">
					<label style={{ fontWeight: 'normal', cursor: displayCheckbox ? null : 'default' }}>
						{displayCheckbox && (
							<input
								type="checkbox"
								name={`${inputFieldType}Group`}
								onChange={handleCheck}
								value={inputField.id}
								data-text={inputField.name}
								data-displayonly={inputField.displayOnly}
								checked={checked}
								disabled={
									disabled || parentChecked || (isMedicareOrder !== true && inputField.displayOnly)
								}
							/>
						)}
						{inputField.name}
					</label>
				</div>
			</div>
			<div className={'cpt col-' + cptColumnWidth}>{inputField.cptCode}</div>
			{showCptQuantity && (
				<div className="col-2 padding-x-0">
					<CptQuantity
						cptQuantityMap={cptQuantityMap}
						inputField={inputField}
						splitCptQty={splitCptQty}
						isMedicareOrder={isMedicareOrder}
						canEdit={!(disableCptQtyUpdate ?? disabled) && isEditingCptQuantity}
						onQtyChange={updateCptQuantity}
					/>
				</div>
			)}
			{!!inputField.gdxItemId && !!priceMap && (
				<div className="col-1">
					<ComponentPrice inputField={inputField} priceMap={priceMap} priceType={priceDisplayType} />
				</div>
			)}
			</div>
		</div>
	);
};

export default ComponentRow;
